import React, { Component } from "react";
import Stepper from "./Stepper";
import moment from "moment";
import "moment-timezone";
import DateRangePicker from "./DateRangePicker";
import { Grid } from "@mui/material";
import Loader from "../../Layout/Loader";
import Scrollbar from "react-scrollbars-custom";

export default class PaymentFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilterModal: false,
      from: "",
      to: "",
      selectedDate: "",
      steps: [{ id: 1, title: "selectServiceTimeControl" }],
      activeStep: 1,
      reportType: 0,
      isSubmitBtn: false,
    };
  }

  showDates = (e, date) => {
    const adjustedEndDate = date.endDate
      .clone()
      .set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    let timezone = "Asia/Riyadh";
    if (
      this.props.ServerSetting &&
      this.props.ServerSetting.attributes &&
      this.props.ServerSetting.attributes.timezone
    ) {
      timezone = this.props.ServerSetting.attributes.timezone;
    }
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);

    const formatedDate = {
      from: moment(date.startDate.format("YYYY-MM-DD HH:mm")).toISOString(),
      to: adjustedEndDate.toISOString(),
    };

    let timeFormat = "HH:mm";
    if (this.props.logInUser && this.props.logInUser.twelveHourFormat) {
      timeFormat = "hh:mm A";
    }

    this.setState({
      selectedDate:
        moment(date.startDate).format("YYYY-MM-DD " + timeFormat) +
        " - " +
        adjustedEndDate.format("YYYY-MM-DD " + timeFormat),
      ...formatedDate,
    });
  };

  goToNextStep = (step, type, index) => {
    const steps = [];
    let validated = false;
    let errorMsg = null;
    if (step === 1) {
      if (this.state.to && this.state.from) {
        validated = true;
        errorMsg = null;
        this.setState(
          {
            openFilterModal: false,
          },
          () => {
            this.props.formSubmit(this.state, type);
          },
        );
      } else {
        validated = false;
        errorMsg = (
          <span className="text-warning">
            {this.props.translate(
              "Please select Date and Maintenance Status from above",
            )}
          </span>
        );
      }
      if (validated === true) {
        this.setState({ isSubmitBtn: true });
      }

      this.state.steps.map((s) => {
        if (s.id === step) {
          steps.push({ ...s, errorMsg });
        } else {
          steps.push(s);
        }
        return null;
      });

      this.setState({ steps });
    }
  };

  goToBackStep = () => {
    const currentStep = this.state.activeStep;
    this.setState({ activeStep: currentStep - 1 });
  };

  getStepContent = (id) => {
    switch (id) {
      case 1:
        return (
          <Grid container className="form-group">
            <Grid item xs={12}>
              <DateRangePicker
                fill
                error={this.props.timeError || false}
                selectedDate={this.state.selectedDate}
                label={
                  this.props.translate("reportFrom") +
                  " - " +
                  this.props.translate("reportTo")
                }
                onEvent={this.showDates}
              />
            </Grid>
          </Grid>
        );
      default:
        return null;
    }
  };

  render() {
    const viewScreen = (
      <form style={{ padding: "10px 0" }}>
        <Stepper
          translate={this.props.translate}
          activeStepInvo={this.state.activeStep}
          reportType={this.state.reportType}
          getStepContent={this.getStepContent}
          steps={this.state.steps}
          handleNext={this.goToNextStep}
          handleBack={this.goToBackStep}
          isSubmitBtn={this.state.isSubmitBtn}
          downloadInvoice={(e) =>
            this.props.downloadInvoice &&
            this.props.downloadInvoice(this.state, e)
          }
          invoices
          btnDisable={this.state.selectedDate}
        />
      </form>
    );

    return (
      <div className="geofence-sidebar-list">
        {!this.props.loader ? <Scrollbar>{viewScreen}</Scrollbar> : <Loader />}
      </div>
    );
  }
}
